var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 36,
    viewBox: "0 0 20 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6166 15.8917C6.26578 14.7608 4.86662 13.5917 4.86662 11.7708C4.86662 9.68167 6.80245 8.225 10.0416 8.225C13.4533 8.225 14.7183 9.85417 14.8333 12.25H19.0691C18.9349 8.95333 16.9224 5.925 12.9166 4.9475V0.75H7.16662V4.89C3.44828 5.695 0.458281 8.11 0.458281 11.8092C0.458281 16.2367 4.11911 18.4408 9.46661 19.725C14.2583 20.875 15.2166 22.5617 15.2166 24.3442C15.2166 25.6667 14.2774 27.775 10.0416 27.775C6.09328 27.775 4.54078 26.0117 4.32995 23.75H0.113281C0.343281 27.9475 3.48661 30.305 7.16662 31.0908V35.25H12.9166V31.1292C16.6541 30.42 19.625 28.2542 19.625 24.325C19.625 18.8817 14.9674 17.0225 10.6166 15.8917Z",
    fill: "#11B355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar-sign.6dc24c5c03279dec4daf6a8a3c313c60.svg";
export { ForwardRef as ReactComponent };